import React from 'react';
import './TimeSelector.css';
import { FaClock } from 'react-icons/fa';

const TimeSelector = ({ selectedTime, onTimeChange, label = "Check-in Time" }) => {
  // Generate time options from 6 AM to 11 PM in 30-minute intervals
  const generateTimeOptions = () => {
    const times = [];
    for (let hour = 6; hour <= 23; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        const displayTime = new Date(`2000-01-01T${timeString}`).toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });
        times.push({ value: timeString, display: displayTime });
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();

  return (
    <div className="time-selector">
      <label className="time-selector-label">
        <FaClock className="time-icon" />
        {label}
      </label>
      <select 
        className="time-selector-input"
        value={selectedTime || ''}
        onChange={(e) => onTimeChange(e.target.value)}
      >
        <option value="">Select time</option>
        {timeOptions.map((time) => (
          <option key={time.value} value={time.value}>
            {time.display}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimeSelector;
